"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TotalSummary = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _summaryKeyValuePair = require("../SummaryKeyValuePair/summaryKeyValuePair");
var _selectors = require("../../../store/quote/selectors");
var _termsAndConditions = require("../TermsAndConditions/termsAndConditions");
var _brandContext = require("../../../contextProviders/brandContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TotalSummary = exports.TotalSummary = function TotalSummary(_ref) {
  var _getTotalAmount;
  var disableContinueBtn = _ref.disableContinueBtn,
    onCheckTermAndConditions = _ref.onCheckTermAndConditions;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.savedQuoteSelector),
    savedQuote = _useSelector.quote;
  var pets = savedQuote.pets;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    showPanel = _useState2[0],
    setShowPanel = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAcceptAndCloseBtnEnabled = _useState4[0],
    setIsAcceptAndCloseBtnEnabled = _useState4[1];
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    useMocks = _useContext.useMocks,
    petSummary = _useContext.activeBrandContext.steps.summary.petSummary;
  var paymentFrequencyCode = savedQuote.paymentFrequencyCode,
    totalPremium = savedQuote.totalPremium,
    totalAnnualAmount = savedQuote.totalAnnualAmount,
    lessFreeMonthAmount = savedQuote.lessFreeMonthAmount,
    totalAnnualFreeMonthAmount = savedQuote.totalAnnualFreeMonthAmount;
  var selectedPaymentFrequency = function selectedPaymentFrequency() {
    if (paymentFrequencyCode === 'ANNUALLY') return 'annual';
    if (paymentFrequencyCode === 'MONTHLY') return 'monthly';
    return 'fortnightly';
  };
  var getTotalAmount = function getTotalAmount() {
    var total = 0;
    if (totalPremium && totalPremium > 0) {
      return totalPremium;
    }
    if (pets.length) {
      pets.forEach(function (pet) {
        var _pet$selectedQuote;
        if (pet !== null && pet !== void 0 && (_pet$selectedQuote = pet.selectedQuote) !== null && _pet$selectedQuote !== void 0 && _pet$selectedQuote.totalPremiumAmount) {
          total += pet.selectedQuote.totalPremiumAmount;
        }
      });
    }
    return total;
  };
  var getPremium = function getPremium(pet) {
    var _pet$selectedQuote2;
    if (totalAnnualAmount && totalAnnualAmount > 0) {
      return totalAnnualAmount;
    }
    if (getTotalAmount() > 0 || pet !== null && pet !== void 0 && (_pet$selectedQuote2 = pet.selectedQuote) !== null && _pet$selectedQuote2 !== void 0 && _pet$selectedQuote2.paymentFrequencyCode) {
      var frequencyFactor = 1;
      frequencyFactor = pet.selectedQuote.paymentFrequencyCode === 'YEARLY' ? 1 : frequencyFactor;
      frequencyFactor = pet.selectedQuote.paymentFrequencyCode === 'MONTHLY' ? 12 : frequencyFactor;
      return getTotalAmount() * frequencyFactor;
    }
    return 0;
  };
  var formatSubTotal = function formatSubTotal() {
    if (lessFreeMonthAmount <= 0 && totalAnnualFreeMonthAmount <= 0 && selectedPaymentFrequency() !== 'annual') {
      return {
        key: 'Total_annual_premium_payable',
        label: 'Total annual premium payable',
        value: getPremium(pets[0])
      };
    }
    return {
      key: 'Annual_premium',
      label: 'Annual premium',
      value: null
    };
  };
  var _formatSubTotal = formatSubTotal(),
    subTotalKey = _formatSubTotal.key,
    subTotalLabel = _formatSubTotal.label,
    subTotalValue = _formatSubTotal.value;
  var isDisplayedFreeMonth = lessFreeMonthAmount > 0 && totalAnnualFreeMonthAmount > 0;
  var handleKeyDown = function handleKeyDown(event) {
    if (event.keyCode && event.keyCode !== 13 && event.keyCode !== 32) {
      return;
    }
    handleTermsAndConditionsOnclick();
  };
  var handleTermsAndConditionsOnclick = function handleTermsAndConditionsOnclick() {
    if (disableContinueBtn) setShowPanel(true);
    setIsAcceptAndCloseBtnEnabled(false);
    onCheckTermAndConditions(disableContinueBtn);
  };
  var handleCloseModal = function handleCloseModal() {
    setShowPanel(false);
    onCheckTermAndConditions(false);
  };
  var handleAcceptAndCloseOnClick = function handleAcceptAndCloseOnClick() {
    setShowPanel(false);
    onCheckTermAndConditions(true);
  };
  var PanelFooter = function PanelFooter() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "scrollDownText"
    }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
      icon: "arrow-down2",
      hidden: isAcceptAndCloseBtnEnabled
    }), "Please scroll to the end to accept the Terms and Conditions"), /*#__PURE__*/_react["default"].createElement("button", {
      id: "AcceptAndCloseBtn",
      className: "button primary",
      type: "button",
      disabled: !isAcceptAndCloseBtnEnabled,
      onClick: handleAcceptAndCloseOnClick
    }, "Accept and Close"));
  };
  var handleScroll = function handleScroll(event) {
    var scrollerAtBottom = event.scrollSettings.scrollerAtBottom;
    if (scrollerAtBottom) {
      setIsAcceptAndCloseBtnEnabled(true);
    }
  };
  var termsAndConditionsLabelGenerator = function termsAndConditionsLabelGenerator(clickHandler, _onKeyDown) {
    if (petSummary !== null && petSummary !== void 0 && petSummary.termsAndConditionsLabel && typeof petSummary.termsAndConditionsLabel === 'function') {
      return petSummary === null || petSummary === void 0 ? void 0 : petSummary.termsAndConditionsLabel(clickHandler, _onKeyDown);
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "I have read and agree to the\xA0", /*#__PURE__*/_react["default"].createElement("span", {
      className: "termLink",
      onClick: clickHandler,
      onKeyDown: function onKeyDown(event) {
        return _onKeyDown(event);
      },
      role: "link",
      "aria-label": "Terms and conditions link",
      tabIndex: 0
    }, "terms and conditions"), " of this policy including but not limited to the privacy statement contained in the Combined Financial Services Guide and Product Disclosure Statement");
  };
  var finalCollectionFee = (0, _react.useMemo)(function () {
    var pets = savedQuote.pets,
      collectionFee = savedQuote.collectionFee;
    if (!collectionFee) {
      var _pet$selectedQuote3;
      var pet = pets === null || pets === void 0 ? void 0 : pets.find(function (item) {
        var selectedQuote = item.selectedQuote;
        var _ref2 = selectedQuote !== null && selectedQuote !== void 0 ? selectedQuote : {},
          totalPremiumAmountWithoutDiscount = _ref2.totalPremiumAmountWithoutDiscount,
          totalBasePremium = _ref2.totalBasePremium,
          totalOtherBaseLoading = _ref2.totalOtherBaseLoading;
        var basePremiumAndOtherBaseLoadingTotal = Number((totalBasePremium + totalOtherBaseLoading).toFixed(2));
        var isCollectionFeeIncluded = basePremiumAndOtherBaseLoadingTotal === totalPremiumAmountWithoutDiscount;
        if (isCollectionFeeIncluded) {
          return item;
        }
        return null;
      });
      var _ref3 = (_pet$selectedQuote3 = pet === null || pet === void 0 ? void 0 : pet.selectedQuote) !== null && _pet$selectedQuote3 !== void 0 ? _pet$selectedQuote3 : {},
        totalBasePremium = _ref3.totalBasePremium,
        totalPremiumAmountWithoutDiscount = _ref3.totalPremiumAmountWithoutDiscount;
      return totalPremiumAmountWithoutDiscount - totalBasePremium;
    }
    return collectionFee;
  }, [savedQuote]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "totalSummary"
  }, /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement("main", null, /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
    key: "Total_".concat(selectedPaymentFrequency(), "_premium_payable"),
    label: "Total ".concat(selectedPaymentFrequency(), " premium payable"),
    value: (0, _helpers.FormatAsCurrency)((_getTotalAmount = getTotalAmount()) !== null && _getTotalAmount !== void 0 ? _getTotalAmount : 0),
    isTotal: true
  }), isDisplayedFreeMonth && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
    key: "Annual_premium",
    label: "Annual premium",
    value: "".concat(!Number.isNaN(+totalAnnualAmount) ? (0, _helpers.FormatAsCurrency)(totalAnnualAmount) : totalAnnualAmount)
  }), /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
    key: "Less_free_months",
    label: "Less free months",
    value: "- ".concat(!Number.isNaN(+lessFreeMonthAmount) ? (0, _helpers.FormatAsCurrency)(lessFreeMonthAmount) : lessFreeMonthAmount)
  }), /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
    key: "Total_Annual_Premium_Payable",
    label: "Total Annual Premium Payable",
    value: "".concat(!Number.isNaN(+totalAnnualFreeMonthAmount) ? (0, _helpers.FormatAsCurrency)(totalAnnualFreeMonthAmount) : totalAnnualFreeMonthAmount)
  })), typeof subTotalValue !== 'undefined' && subTotalValue > 0 && /*#__PURE__*/_react["default"].createElement(_summaryKeyValuePair.SummaryKeyValuePair, {
    key: subTotalKey,
    label: subTotalLabel,
    value: !Number.isNaN(+subTotalValue) ? (0, _helpers.FormatAsCurrency)(subTotalValue) : subTotalValue
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "noteText secondaryText"
  }, /*#__PURE__*/_react["default"].createElement("p", null, "Premiums include GST and Stamp Duty"), (petSummary === null || petSummary === void 0 ? void 0 : petSummary.collectionFeeStatement) && typeof petSummary.collectionFeeStatement === 'function' && finalCollectionFee > 0 && Number.isFinite(finalCollectionFee) && petSummary.collectionFeeStatement((0, _helpers.FormatAsCurrency)(finalCollectionFee)) || null, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Please note:"), " Due to rounding your first premium amount may be slightly different with the remaining instalments being a consistent amount.")), /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement("fieldset", null, /*#__PURE__*/_react["default"].createElement(_components.InputCheckbox, {
    key: "Terms_and_Conditions",
    name: "Terms_and_Conditions",
    id: "terms_and_conditions",
    autoComplete: "off",
    customCssClass: "customCheckboxCss",
    inputCustomCssClass: "customInputCheckboxCss",
    checked: !disableContinueBtn,
    customChangeHandler: handleTermsAndConditionsOnclick,
    required: true,
    label: termsAndConditionsLabelGenerator(handleTermsAndConditionsOnclick, handleKeyDown)
  }))))), showPanel && /*#__PURE__*/_react["default"].createElement(_components.Panel, {
    header: {
      fixed: true,
      content: 'Terms and Conditions'
    },
    footer: {
      fixed: true,
      content: /*#__PURE__*/_react["default"].createElement(PanelFooter, null)
    },
    type: "modal",
    onClose: handleCloseModal,
    open: showPanel,
    scrollContent: true,
    customCssClass: "petsureForm termsAndConditions",
    onPanelScroll: handleScroll
  }, /*#__PURE__*/_react["default"].createElement(_termsAndConditions.TermsAndConditions, {
    totalAmount: getTotalAmount()
  })));
};
TotalSummary.propTypes = {
  disableContinueBtn: _propTypes["default"].bool,
  onCheckTermAndConditions: _propTypes["default"].func
};